import { Box, Button, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { repositorySign } from "../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../model/MessageResponse";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { IconTrash } from "@tabler/icons-react";

const DeleteTableView = ({ ids, onSearch }: DeleteTableViewProps) => {
  const handleDeleteDocType = async () => {
    let url = "/api/v1/TblDocument/delete?id=" + ids;
    const response = await repositorySign.get<MessageResponse<boolean>>(url);
    if (response && response.success) {
      await onSearch();
      NotificationExtension.Success("Xóa loại tài liệu thành công !");
    } else {
      NotificationExtension.Fails(
        response?.message || "Xóa loại tài liệu thất bại !"
      );
    }
    modals.closeAll();
  };
  return (
    <>
      <Box pb={0}>
        <Text size="16px">Bạn có chắc chắn muốn xóa hồ sơ không?</Text>
        <Group pb={0} justify="flex-end" mt={20}>
          <Button
            type="button"
            variant="default"
            onClick={() => modals.closeAll()}
            leftSection={<IconX size={18} />}
          >
            Hủy
          </Button>
          <Button
            type="button"
            color="red"
            onClick={handleDeleteDocType}
            leftSection={<IconTrash size={18} />}
          >
            Xóa
          </Button>
        </Group>
      </Box>
    </>
  );
};

type DeleteTableViewProps = {
  ids: number;
  onSearch: () => void;
};
export default DeleteTableView;
